// extracted by mini-css-extract-plugin
module.exports = {"expiredTitle":"warning_expiredTitle__3UrjL","expiredText":"warning_expiredText__1EU9j","expiredLink":"warning_expiredLink__10Jzj"};